import script from "./ReligionInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ReligionInput.vue?vue&type=script&setup=true&lang=js"

import "./ReligionInput.vue?vue&type=style&index=0&id=1eee7c2b&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eee7c2b"]])

export default __exports__